// extracted by mini-css-extract-plugin
export default {"container":"companyShow_container__StN8-","tableCard":"companyShow_tableCard__8K22i","showCurrency":"companyShow_showCurrency__4mo+0"};